import { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";


const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const [page, setPage] = useState(currentPage || 1);
  console.log(currentPage, page);

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage);
    }
  }, [currentPage]);

  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
      onPageChange(page - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
      onPageChange(page + 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
    onPageChange(pageNumber);
  };

  const renderPageNumbers = () => {
    const pages = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= page - 1 && i <= page + 1)) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`mx-1 px-[14px] py-[8px] text-[14px] rounded-lg ${
              i === page ? "bg-[#FEBA06] text-white" : "text-black"
            }`}
          >
            {i}
          </button>
        );
      } else if (
        (i === page - 2 && page > 3) ||
        (i === page + 2 && page < totalPages - 2)
      ) {
        pages.push(
          <span key={i} className="mx-1 text-black">
            ...
          </span>
        );
      }
    }
    return pages;
  };

  return (
    <div className="flex items-center justify-center space-x-2">
      {/* Previous Button */}
      <button
        onClick={handlePrevious}
        disabled={page === 1}
        className={`text-black flex items-center ${
          page === 1 ? "text-gray-400 cursor-not-allowed" : "hover:text-gray-600"
        }`}
      >
        <span className="mr-[7px]"><FaArrowLeft /></span> Previous
      </button>

      {/* Page Numbers */}
      {renderPageNumbers()}

      {/* Next Button */}
      <button
        onClick={handleNext}
        disabled={page === totalPages}
        className={`text-black flex items-center ${
          page === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "hover:text-gray-600"
        }`}
      >
        Next <span className="ml-[7px]"><FaArrowRight/></span>
      </button>
    </div>
  );
};

export default Pagination;
